<script setup lang="ts">
import { onMounted, ref, useTemplateRef } from 'vue'
import { useStaticAsset } from '@/composables/useStaticAsset'
import { loadYandexMaps } from '@/lib/ymaps'

const asset = useStaticAsset()

const props = defineProps<{
  location: { lat: number; long: number }
}>()

const mapRef = useTemplateRef<HTMLElement>('mapRef')
const map = ref<ymaps.Map | null>(null)
const placemarks = ref<ymaps.Placemark[]>([])
const loading = ref(true)

onMounted(async () => {
  const ymaps = await loadYandexMaps()
  map.value = new ymaps.Map(mapRef.value, {
    center: [55.751574, 37.573856], // Москва
    zoom: 15,
    controls: [
      new ymaps.control.GeolocationControl({
        options: { float: 'right' }
      }),
      new ymaps.control.ZoomControl({
        options: { position: { left: 'auto', right: 10, top: 108, bottom: 'auto' } }
      })
    ]
  })

  const placemark = new ymaps.Placemark(
    [props.location.lat, props.location.long],
    {},
    {
      iconLayout: 'default#image',
      iconImageHref: asset('img/map-marker-blue.svg'),
      iconImageSize: [32, 32],
      iconImageOffset: [0, -24]
    }
  )

  placemarks.value.push(placemark)
  map.value!.geoObjects.add(placemark)
  map.value!.setCenter([props.location.lat, props.location.long])

  loading.value = false
})
</script>

<template>
  <div class="events-map">
    <div ref="mapRef" class="events-map__ymap" />

    <transition name="fade">
      <div v-if="loading" class="events-map__preloader">
        <div class="events-map__preloader-card blue-text">
          <v-icon class="mdi-spin mb-2" size="36">mdi-timer-sand</v-icon>
          Загрузка...
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
.events-map {
  height: 300px;
  position: relative;
  overflow: hidden;

  border-radius: 8px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);

  &__ymap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &__preloader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    z-index: 2;
    background: rgba(white, 0.5);
    user-select: none;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__preloader-card {
    border-radius: 8px;
    padding: 16px 24px;
    background: white;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);

    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
  }
}
</style>
